import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FeaturesApi } from '../../../apis/FeaturesApi/FeaturesApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export function useSetFeatureEnabled() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ featureId, isEnabled }: { featureId: number; isEnabled: boolean }) =>
            FeaturesApi.setFeatureEnabled(featureId, isEnabled),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.allFeatures] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.visibleFeatures] });
        },
    });
}
